import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Login logic would go here
    console.log('Login attempt:', { email, password });
    
    // Simular login exitoso y redirigir al dashboard
    if (email && password) {
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background with Aztec Eagle and Mexican Flag */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=majestic%20aztec%20eagle%20with%20spread%20wings%20in%20traditional%20mexican%20art%20style%2C%20golden%20eagle%20with%20detailed%20feathers%20perched%20on%20cactus%2C%20mexican%20flag%20colors%20green%20white%20and%20red%20vertical%20stripes%20background%2C%20national%20coat%20of%20arms%20inspiration%2C%20patriotic%20symbolism%2C%20aztec%20warrior%20eagle%20design%2C%20vibrant%20emerald%20green%20white%20crimson%20red%20flag%20backdrop%2C%20traditional%20mexican%20heraldic%20eagle%2C%20powerful%20bird%20with%20snake%20in%20beak%2C%20dramatic%20lighting%2C%20national%20pride%20imagery&width=1920&height=1080&seq=aztec-eagle-mexican-flag-001&orientation=landscape')`
        }}
      />
      
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/40" />
      
      {/* Login Form Container */}
      <div className="relative z-10 w-full max-w-md mx-4">
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20">
          {/* Logo */}
          <div className="text-center mb-8">
            <img
              src="https://storage.readdy-site.link/project_files/84f75d7c-5aa3-41e4-b7ad-dd29b3b984c6/838cdbab-d32d-4b26-b12c-15bffc18506a_poktapok_v1_sin-fondo.png"
              alt="PokTaPok"
              className="h-24 w-auto object-contain mx-auto mb-3"
            />
            <p className="text-gray-600">Inicia sesión en tu cuenta</p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email Field */}
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Correo Electrónico
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="ri-mail-line text-gray-400"></i>
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  placeholder="tu@email.com"
                />
              </div>
            </div>

            {/* Password Field */}
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Contraseña
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="ri-lock-line text-gray-400"></i>
                </div>
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  placeholder="Tu contraseña"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                >
                  <i className={showPassword ? 'ri-eye-off-line text-gray-400' : 'ri-eye-line text-gray-400'}></i>
                </button>
              </div>
            </div>

            {/* Login Button */}
            <Button 
              type="submit"
              className="w-full bg-green-700 hover:bg-green-800 text-white py-3 rounded-lg font-medium transition-colors whitespace-nowrap"
            >
              Iniciar Sesión
            </Button>
          </form>

          {/* Forgot Password Link */}
          <div className="mt-6 text-center">
            <Link 
              to="/recuperar-contrasena"
              className="text-red-600 hover:text-red-700 font-medium transition-colors cursor-pointer"
            >
              ¿Olvidaste tu contraseña?
            </Link>
          </div>

          {/* Register Link */}
          <div className="mt-8 text-center pt-6 border-t border-gray-200">
            <p className="text-gray-600">
              ¿No tienes cuenta?{' '}
              <Link 
                to="/registro"
                className="text-green-700 hover:text-green-800 font-medium transition-colors cursor-pointer"
              >
                Regístrate aquí
              </Link>
            </p>
          </div>

          {/* Back to Home */}
          <div className="mt-4 text-center">
            <Link 
              to="/"
              className="inline-flex items-center space-x-2 text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Volver al inicio</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
